var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessImports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7188 3.09375C52.5195 3.09375 49.0504 6.24937 48.5399 10.3125H46.4062C44.7006 10.3125 43.3125 11.7006 43.3125 13.4062V29.9062H34.0312V17.4601C38.0944 16.9496 41.25 13.4805 41.25 9.28125C41.25 4.73241 37.5488 1.03125 33 1.03125C28.4512 1.03125 24.75 4.73241 24.75 9.28125C24.75 13.4805 27.9056 16.9496 31.9688 17.4601V29.9062H25.3543L22.6875 32.5731V13.4062C22.6875 11.7006 21.2994 10.3125 19.5938 10.3125H17.4601C16.9496 6.24937 13.4805 3.09375 9.28125 3.09375C4.73241 3.09375 1.03125 6.79491 1.03125 11.3438C1.03125 15.8926 4.73241 19.5938 9.28125 19.5938C13.4805 19.5938 16.9496 16.4381 17.4601 12.375H19.5938C20.163 12.375 20.625 12.838 20.625 13.4062V34.6356L18.5625 36.6981V48.4688H16.5V27.8438H18.5625V25.7812H16.5C15.3625 25.7812 14.4375 26.7063 14.4375 27.8438V48.4688C14.4375 49.6062 15.3625 50.5312 16.5 50.5312H37.125V52.5938H15.4688C13.7631 52.5938 12.375 51.2057 12.375 49.5V26.8125C12.375 25.1068 13.7631 23.7188 15.4688 23.7188H18.5625V21.6562H15.4688C12.6256 21.6562 10.3125 23.9693 10.3125 26.8125V49.5C10.3125 52.3432 12.6256 54.6562 15.4688 54.6562H24.75V56.7188H21.6562C19.9506 56.7188 18.5625 58.1068 18.5625 59.8125V61.875C18.5625 63.5807 19.9506 64.9688 21.6562 64.9688H44.3438C46.0494 64.9688 47.4375 63.5807 47.4375 61.875V59.8125C47.4375 58.1068 46.0494 56.7188 44.3438 56.7188H41.25V54.6562H50.5312C53.3744 54.6562 55.6875 52.3432 55.6875 49.5V26.8125C55.6875 23.9693 53.3744 21.6562 50.5312 21.6562H47.4375V23.7188H50.5312C52.2369 23.7188 53.625 25.1068 53.625 26.8125V44.3438H51.5625V27.8438C51.5625 26.7063 50.6375 25.7812 49.5 25.7812H47.4375V27.8438H49.5V44.3438H47.4375V29.9062H45.375V13.4062C45.375 12.838 45.837 12.375 46.4062 12.375H48.5399C49.0504 16.4381 52.5195 19.5938 56.7188 19.5938C61.2676 19.5938 64.9688 15.8926 64.9688 11.3438C64.9688 6.79491 61.2676 3.09375 56.7188 3.09375ZM26.8125 9.28125C26.8125 8.55731 26.9445 7.86534 27.1734 7.21875H29.107C28.9658 7.87153 28.875 8.55834 28.875 9.28125C28.875 10.0042 28.9658 10.691 29.107 11.3438H27.1734C26.9445 10.6972 26.8125 10.0052 26.8125 9.28125ZM30.9375 9.28125C30.9375 8.55628 31.0509 7.86431 31.2283 7.21875H34.7758C34.9501 7.86328 35.0625 8.55422 35.0625 9.28125C35.0625 10.0062 34.9491 10.6982 34.7727 11.3438H31.2252C31.0499 10.6992 30.9375 10.0083 30.9375 9.28125ZM32.0574 5.15625C32.3761 4.55916 32.7133 4.059 33.0021 3.67022C33.2918 4.05797 33.6291 4.55916 33.9477 5.15625H32.0574ZM39.1875 9.28125C39.1875 10.0052 39.0555 10.6972 38.8266 11.3438H36.8796C37.0219 10.6889 37.125 10.0062 37.125 9.28125C37.125 8.55834 37.0343 7.87153 36.893 7.21875H38.8266C39.0555 7.86534 39.1875 8.55731 39.1875 9.28125ZM33.9426 13.4062C33.6239 14.0033 33.2867 14.5035 32.9979 14.8923C32.7082 14.5045 32.3709 14.0033 32.0523 13.4062H33.9426ZM35.4265 14.9717C35.7039 14.5107 35.9752 13.9807 36.2227 13.4062H37.5983C37.0002 14.0735 36.2629 14.6138 35.4265 14.9717ZM37.5994 5.15625H36.2299C35.9824 4.58081 35.7081 4.05488 35.4307 3.59184C36.2649 3.94969 37.0002 4.49006 37.5994 5.15625ZM30.5704 3.59184C30.2919 4.05488 30.0176 4.58081 29.7701 5.15625H28.4006C28.9998 4.49006 29.7351 3.94969 30.5704 3.59184ZM28.4006 13.4062H29.7701C30.0176 13.9817 30.2919 14.5076 30.5693 14.9707C29.7351 14.6128 28.9998 14.0724 28.4006 13.4062V13.4062ZM13.8806 7.21875H12.5111C12.2636 6.64331 11.9893 6.11737 11.7119 5.65434C12.5462 6.01219 13.2815 6.55256 13.8806 7.21875ZM15.4688 11.3438C15.4688 12.0677 15.3367 12.7597 15.1078 13.4062H13.1742C13.3155 12.7535 13.4062 12.0667 13.4062 11.3438C13.4062 10.6208 13.3155 9.93403 13.1742 9.28125H15.1078C15.3367 9.92784 15.4688 10.6198 15.4688 11.3438ZM7.50647 13.4062C7.33116 12.7617 7.21875 12.0708 7.21875 11.3438C7.21875 10.6188 7.33219 9.92681 7.50956 9.28125H11.0571C11.2313 9.92578 11.3438 10.6167 11.3438 11.3438C11.3438 12.0687 11.2303 12.7607 11.054 13.4062H7.50647ZM10.2238 15.4688C9.90516 16.0658 9.56794 16.566 9.27919 16.9548C8.98941 16.567 8.65219 16.0658 8.33353 15.4688H10.2238ZM3.09375 11.3438C3.09375 10.6198 3.22575 9.92784 3.45469 9.28125H5.38828C5.247 9.93403 5.15625 10.6208 5.15625 11.3438C5.15625 12.0667 5.247 12.7535 5.38828 13.4062H3.45469C3.22575 12.7597 3.09375 12.0677 3.09375 11.3438V11.3438ZM8.33869 7.21875C8.65734 6.62166 8.99456 6.1215 9.28331 5.73272C9.57309 6.12047 9.91031 6.62166 10.229 7.21875H8.33869ZM6.85163 5.65434C6.57319 6.11737 6.29888 6.64331 6.05138 7.21875H4.68187C5.28103 6.55256 6.01631 6.01219 6.85163 5.65434ZM4.68187 15.4688H6.05138C6.29888 16.0442 6.57319 16.5701 6.85059 17.0332C6.01631 16.6753 5.28103 16.1349 4.68187 15.4688V15.4688ZM11.7109 17.0332C11.9883 16.5712 12.2626 16.0452 12.5101 15.4688H13.8796C13.2815 16.1349 12.5462 16.6753 11.7109 17.0332ZM24.75 33.4269V36.0938H22.0832L24.75 33.4269ZM44.3438 58.7812C44.913 58.7812 45.375 59.2433 45.375 59.8125V61.875C45.375 62.4442 44.913 62.9062 44.3438 62.9062H21.6562C21.087 62.9062 20.625 62.4442 20.625 61.875V59.8125C20.625 59.2433 21.087 58.7812 21.6562 58.7812H24.75C24.75 59.9187 25.7524 60.8438 26.9847 60.8438H39.0153C40.2476 60.8438 41.25 59.9187 41.25 58.7812H44.3438ZM39.204 58.7194C39.1947 58.7317 39.1318 58.7812 39.0153 58.7812H26.9847C26.8795 58.7823 26.8208 58.7431 26.8125 58.7689V54.6562H39.1906L39.204 58.7194ZM53.625 49.5C53.625 51.2057 52.2369 52.5938 50.5312 52.5938H39.1875V46.4062H53.625V49.5ZM39.1875 44.3438C38.05 44.3438 37.125 45.2688 37.125 46.4062V48.4688H20.625V38.1562H26.8125V31.9688H45.375V44.3438H39.1875ZM61.3181 7.21875H59.9486C59.7011 6.64331 59.4268 6.11737 59.1494 5.65434C59.9837 6.01219 60.719 6.55256 61.3181 7.21875ZM62.9062 11.3438C62.9062 12.0677 62.7743 12.7597 62.5453 13.4062H60.6117C60.753 12.7535 60.8438 12.0667 60.8438 11.3438C60.8438 10.6208 60.753 9.93403 60.6117 9.28125H62.5453C62.7743 9.92784 62.9062 10.6198 62.9062 11.3438ZM54.944 13.4062C54.7687 12.7617 54.6562 12.0708 54.6562 11.3438C54.6562 10.6188 54.7697 9.92681 54.9471 9.28125H58.4946C58.6688 9.92578 58.7812 10.6167 58.7812 11.3438C58.7812 12.0687 58.6678 12.7607 58.4915 13.4062H54.944ZM57.6613 15.4688C57.3427 16.0658 57.0054 16.566 56.7167 16.9548C56.4269 16.567 56.0897 16.0658 55.771 15.4688H57.6613ZM50.5312 11.3438C50.5312 10.6198 50.6632 9.92784 50.8922 9.28125H52.8258C52.6845 9.93403 52.5938 10.6208 52.5938 11.3438C52.5938 12.0667 52.6845 12.7535 52.8258 13.4062H50.8922C50.6632 12.7597 50.5312 12.0677 50.5312 11.3438ZM55.7762 7.21875C56.0948 6.62166 56.4321 6.1215 56.7208 5.73272C57.0106 6.12047 57.3478 6.62166 57.6665 7.21875H55.7762ZM54.2891 5.65434C54.0107 6.11737 53.7364 6.64331 53.4889 7.21875H52.1194C52.7185 6.55256 53.4538 6.01219 54.2891 5.65434V5.65434ZM52.1194 15.4688H53.4889C53.7364 16.0442 54.0107 16.5701 54.2881 17.0332C53.4538 16.6753 52.7185 16.1349 52.1194 15.4688ZM59.1484 17.0332C59.4258 16.5712 59.7001 16.0452 59.9476 15.4688H61.3171C60.719 16.1349 59.9837 16.6753 59.1484 17.0332Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 21.6562H29.9062V23.7188H24.75V21.6562Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0938 21.6562H41.25V23.7188H36.0938V21.6562Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0938 25.7812H41.25V27.8438H36.0938V25.7812Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 25.7812H29.9062V27.8438H24.75V25.7812Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 48.4688H51.5625V50.5312H49.5V48.4688Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.375 48.4688H47.4375V50.5312H45.375V48.4688Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 48.4688H43.3125V50.5312H41.25V48.4688Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 36.0938H43.3125V38.1562H28.875V36.0938Z",
    fill: "url(#paint8_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 40.2188H43.3125V42.2812H22.6875V40.2188Z",
    fill: "url(#paint9_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 44.3438H24.75V46.4062H22.6875V44.3438Z",
    fill: "url(#paint10_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 44.3438H28.875V46.4062H26.8125V44.3438Z",
    fill: "url(#paint11_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 44.3438H33V46.4062H30.9375V44.3438Z",
    fill: "url(#paint12_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.8846,
    y1: 64.9687,
    x2: 32.8846,
    y2: 1.03125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 27.3188,
    y1: 23.7187,
    x2: 27.3188,
    y2: 21.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 38.6626,
    y1: 23.7187,
    x2: 38.6626,
    y2: 21.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 38.6626,
    y1: 27.8437,
    x2: 38.6626,
    y2: 25.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 27.3188,
    y1: 27.8437,
    x2: 27.3188,
    y2: 25.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 50.5275,
    y1: 50.5312,
    x2: 50.5275,
    y2: 48.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 46.4025,
    y1: 50.5312,
    x2: 46.4025,
    y2: 48.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 42.2775,
    y1: 50.5312,
    x2: 42.2775,
    y2: 48.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 36.0677,
    y1: 38.1562,
    x2: 36.0677,
    y2: 36.0937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 32.9628,
    y1: 42.2812,
    x2: 32.9628,
    y2: 40.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 23.715,
    y1: 46.4062,
    x2: 23.715,
    y2: 44.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 27.84,
    y1: 46.4062,
    x2: 27.84,
    y2: 44.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 31.965,
    y1: 46.4062,
    x2: 31.965,
    y2: 44.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessImports);
export default __webpack_public_path__ + "static/media/process--imports.7f89db2fdb55ab2e9d015e5a1c1088ee.svg";
export { ForwardRef as ReactComponent };